import GlobalFonts from 'globalStyles/globalStyles'
import AssinaturaNewsletter from './AssinaturaNewsletter'
import ComoFazer from './ComoFazer'
import NossasPlantas from './NossasPlantas'

export default function Home () {
	return (
		<>
			<GlobalFonts />
			<AssinaturaNewsletter />
			<ComoFazer />
			<NossasPlantas />
		</>
	)
}